import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import { Flex } from "../../style";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ConfirmationDialog from '../Confirmation';
import config from '../../config';
import getCookie from '../../hooks/getCookie';

import "../../index.css";

const DetailBox = styled('div')(({ theme }) => ({
  backgroundColor: '#313940',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(3),
  color: 'white',
  maxWidth: 300,
  minWidth: 280,
  overflowY: 'auto',
}));

const colorPalette = [
  '#267B41', '#AC4E00', '#B32D00', '#7E41AC', '#0052B4', '#FF5733', '#33FF57', '#3357FF', '#FF33A6',
  '#A633FF', '#FFC300', '#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#FFEB3B', '#03A9F4', '#E91E63',
  '#FF5722', '#673AB7', '#795548', '#607D8B', '#FF4081', '#8BC34A', '#00BCD4', '#009688', '#FF5252',
  '#FFA726', '#FF7043', '#FFB74D', '#FFCA28', '#FFD54F', '#FFEE58', '#4FC3F7', '#4DD0E1',
  '#4DB6AC', '#81C784', '#AED581', '#DCE775', '#FFF176', '#FFD180', '#FFAB91', '#BCAAA4', '#EEEEEE',
  '#B0BEC5', '#90A4AE', '#78909C', '#546E7A', '#455A64', '#37474F', '#263238', '#1A237E',
  '#0D47A1', '#1565C0', '#1976D2', '#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#42A5F5',
];

const Etiquetas = ({ anchorEl, onClose, handleSetSelectedTag, selectedCard, fetchTagsInCards }) => {
  const [etiquetas, setEtiquetas] = useState([]);
  const [filteredEtiquetas, setFilteredEtiquetas] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [createLabel, setCreateLabel] = useState(false);
  const [newLabelName, setNewLabelName] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [checkedItems, setCheckedItems] = useState([]);
  const [editLabel, setEditLabel] = useState(false);
  const [editLabelName, setEditLabelName] = useState('');
  const [editLabelColor, setEditLabelColor] = useState('');
  const [editLabelTagId, setEditLabelTagId] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);

  const boardId = localStorage.getItem('boardId');

  const sessionId = getCookie('session_id');
  const username = getCookie('username');


  // ip do backend
  const backendIp = config.backend_ip;

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/list_tags`, {
        'board_id': boardId,
        'session_id': sessionId,
        'user': username
      });

      setEtiquetas(response.data);
      setFilteredEtiquetas(response.data);
      setCheckedItems(Array(response.data.length).fill(false));

    } catch (error) {
      return null;
    }
  };

  const handleEditTag = async () => {
    try {
      await axios.put(`${backendIp}/api/board/ti/update_tag`, {
        tag_name: editLabelName,
        color_hex: editLabelColor,
        tag_id: editLabelTagId,
        user: username,
        session_id: sessionId
      });
      setEditLabel(false);
      setEditLabelName('');
      setEditLabelColor('');
      fetchTagsInCards();
      fetchTags();
    } catch (error) {
      return null;
    }
  };

  const handleCreateTag = async () => {
    try {
      await axios.put(`${backendIp}/api/board/ti/create_tag`, {
        color_hex: selectedColor,
        tag_name: newLabelName,
        board_id: boardId,
        user: username,
        session_id: sessionId
      });

      setNewLabelName('');
      setSelectedColor('');
      fetchTags();
      handleClose();

    } catch (error) {
      return null;
    }
  };

  const handleDeleteTag = async (tagId) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/delete_tag`, {
        tag_id: tagId,
        user: username,
        session_id: sessionId
      });
      fetchTags();
      handleClose();
      setDialogOpen(false);
    } catch (error) {
      return null;
    }
  };

  const handleSetTag = async (tagId) => {
    try {
      handleSetSelectedTag(tagId);
    } catch (error) {
      return null;
    }
  };

  const handleDivClick = (index) => {
    const newCheckedItems = [...checkedItems];
    newCheckedItems[index] = !newCheckedItems[index];
    setCheckedItems(newCheckedItems);
  };

  const handleClose = () => {
    onClose();
    setCreateLabel(false);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setFilteredEtiquetas(etiquetas.filter(etiqueta =>
      etiqueta.tag_name.toLowerCase().includes(value.toLowerCase())
    ));
  };

  const handleCreateLabelClick = () => {
    setCreateLabel(true);
  };

  const handleEditLabelClick = (index) => {
    const etiqueta = etiquetas[index];
    setEditLabel(true);
    setEditLabelName(etiqueta.tag_name);
    setEditLabelColor(etiqueta.color_hex);
    setEditLabelTagId(etiqueta.tag_id);
  };

  // Função para calcular o brilho da cor
  const getBrightness = (hex) => {
    let r, g, b;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    } else {
      return null;
    }

    return (r * 299 + g * 587 + b * 114) / 1000;
  };

  const isDark = (hex) => {
    const brightness = getBrightness(hex);
    return brightness < 128;
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DetailBox>
          <p className='paragraph-members'>Etiquetas</p>
          <TextField
            placeholder='Buscar etiquetas'
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            id="outlined-size-small"
            size="small"
            sx={{
              width: '280px',
              marginRight: '10px',
              borderRadius: '6px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'var(--textfield-bg-color, #fff)',
                color: 'var(--textfield-text-color, #000)',
                '& fieldset': {
                  borderColor: 'var(--textfield-border-color, #ccc)',
                },
                '&:hover fieldset': {
                  borderColor: 'var(--textfield-hover-border-color, #aaa)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--textfield-focus-border-color)',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'var(--textfield-label-color, #000)',
              },
              '& .Mui-focused .MuiInputLabel-root': {
                color: 'var(--textfield-label-focus-color)',
              },
              '& .MuiInputBase-input': {
                color: 'var(--textfield-text-color, #000)',
              },
            }}
          />
          <p className='paragraph-members2'>Etiquetas</p>
          <ul style={{ padding: '0px' }}>
            {filteredEtiquetas.map((etiqueta, index) => (
              <li key={index} style={{ display: 'flex', alignItems: 'center', borderRadius: '6px' }} >
                <div onClick={() => handleSetTag(etiqueta.tag_id)}>
                  <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => handleDivClick(index)}>
                    <div
                      className='div-etiquetas'
                      style={{
                        backgroundColor: etiqueta.color_hex,
                        display: 'flex',
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        padding: '2px',
                        fontWeight: 500,
                        color: isDark(etiqueta.color_hex) ? 'white' : 'black' // Define a cor do texto com base na cor de fundo
                      }}
                    >
                      {etiqueta.tag_name}
                    </div>
                  </div>
                </div>
                <IconButton aria-label="edit" className='icon-etiquetas' style={{ marginBottom: '5px' }} onClick={() => handleEditLabelClick(index)}>
                  <EditIcon style={{ width: '16px' }} />
                </IconButton>
                <IconButton aria-label="edit" className='icon-etiquetas' style={{ marginBottom: '5px' }} onClick={() => handleSetTag(etiqueta.tag_id)}>
                  <CloseRoundedIcon style={{ width: '18px' }} />
                </IconButton>
              </li>
            ))}
          </ul>
          <button className='button-etiqueta' onClick={handleCreateLabelClick} >
            Criar uma nova etiqueta
          </button>
        </DetailBox>
      </Popover>

      <Popover
        open={createLabel}
        anchorEl={anchorEl}
        onClose={() => setCreateLabel(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DetailBox>
          <div style={{ display: 'flex' }}>
            <ArrowBackIosIcon style={{ color: '#9fadbc', fontSize: '18px', position: 'relative', cursor: 'pointer' }} onClick={() => setCreateLabel(false)} />
            <p className='paragraph-members3'>Nova Etiqueta</p>
          </div>
          <TextField
            placeholder='Título da etiqueta'
            variant="outlined"
            value={newLabelName}
            onChange={(e) => setNewLabelName(e.target.value)}
            id="outlined-size-small"
            size="small"
            sx={{
              width: '280px',
              marginRight: '10px',
              borderRadius: '6px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'var(--textfield-bg-color, #fff)',
                color: 'var(--textfield-text-color, #000)',
                '& fieldset': {
                  borderColor: 'var(--textfield-border-color, #ccc)',
                },
                '&:hover fieldset': {
                  borderColor: 'var(--textfield-hover-border-color, #aaa)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--textfield-focus-border-color)',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'var(--textfield-label-color, #000)',
              },
              '& .Mui-focused .MuiInputLabel-root': {
                color: 'var(--textfield-label-focus-color)',
              },
              '& .MuiInputBase-input': {
                color: 'var(--textfield-text-color, #000)',
              },
            }}
          />
          <p className='paragraph-members2'>Selecionar uma cor</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', padding: '10px 0' }}>
            {colorPalette.map((color, index) => (
              <div
                key={index}
                onClick={() => setSelectedColor(color)}
                style={{
                  backgroundColor: color,
                  width: '40px',
                  height: '30px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  border: selectedColor === color ? '2px solid white' : 'none'
                }}
              ></div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              onClick={handleCreateTag}
              className='button-etiqueta'
            >
              Criar
            </Button>
          </div>
        </DetailBox>
      </Popover>

      <Popover
        open={editLabel}
        anchorEl={anchorEl}
        onClose={() => setEditLabel(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DetailBox>
          <div style={{ display: 'flex' }}>
            <ArrowBackIosIcon style={{ color: '#9fadbc', fontSize: '18px', position: 'relative', cursor: 'pointer' }} onClick={() => setEditLabel(false)} />
            <p className='paragraph-members3'>Editar Etiqueta</p>
          </div>
          <TextField
            placeholder='Título da etiqueta'
            variant="outlined"
            value={editLabelName}
            onChange={(e) => setEditLabelName(e.target.value)}
            id="outlined-size-small"
            size="small"
            sx={{
              width: '280px',
              marginRight: '10px',
              borderRadius: '6px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'var(--textfield-bg-color, #fff)',
                color: 'var(--textfield-text-color, #000)',
                '& fieldset': {
                  borderColor: 'var(--textfield-border-color, #ccc)',
                },
                '&:hover fieldset': {
                  borderColor: 'var(--textfield-hover-border-color, #aaa)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--textfield-focus-border-color)',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'var(--textfield-label-color, #000)',
              },
              '& .Mui-focused .MuiInputLabel-root': {
                color: 'var(--textfield-label-focus-color)',
              },
              '& .MuiInputBase-input': {
                color: 'var(--textfield-text-color, #000)',
              },
            }}
          />
          <p className='paragraph-members2'>Selecionar uma cor</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', padding: '10px 0' }}>
            {colorPalette.map((color, index) => (
              <div
                key={index}
                onClick={() => setEditLabelColor(color)}
                style={{
                  backgroundColor: color,
                  width: '40px',
                  height: '30px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  border: editLabelColor === color ? '2px solid white' : 'none'
                }}
              ></div>
            ))}
          </div>
          <Flex style={{ marginTop: '10px', justifyContent: 'end' }}>
            <Button
              onClick={handleEditTag}
              className='button-etiqueta'
            >
              Salvar
            </Button>
            <Button
              onClick={() => setDialogOpen(true)}
              style={{ textTransform: 'none', color: 'white', background: '#f87168', border: 'none', borderRadius: '6px', padding: '10px', width: '100px', cursor: 'pointer', height: '40px' }}
            >
              Excluir
            </Button>
            <ConfirmationDialog
              open={dialogOpen}
              onClose={() => setDialogOpen(false)}
              onConfirm={() => handleDeleteTag(editLabelTagId)}
              title="Confirmar Exclusão"
              message="Tem certeza de que deseja excluir a etiqueta? Esta ação não pode ser desfeita."
            />
          </Flex>
        </DetailBox>
      </Popover>
    </Box>
  );
}

export default Etiquetas;